/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2022-03-03 16:37:18
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/CheckItem/CheckItem.tsx
 */
/**
 *  A set of multi-selected components with a title
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */
import React, { memo } from 'react';
import css from './CheckItem.less';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Checkbox } from '@/src/components/Antd';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';

const CheckItem = (props) => {
  const { setCheck, title, checkList, check, setErr, err } = props;

  const handleChange = (e) => {
    setCheck(e.target.value);
    if (err) setErr(false);
  };

  return (
    <Row
      elements={[
        {
          child: (
            <TopContainer>
              <ItemWrapper title={title} containerClassName={css.checkBox}>
                {checkList.map((item, index) => (
                  <div key={index}>
                    <Checkbox
                      className={css.checkItem}
                      onChange={(value, e) => handleChange(e)}
                      checked={check.includes(item.key)}
                      key={item.key}
                      value={item.key}>
                      {item.name}
                    </Checkbox>

                    {(item.children || []).length &&
                    check.includes(item.key) ? (
                      <div className={css.subContainer}>
                        {item.children.map((child, keyIndex) => (
                          <Checkbox
                            key={keyIndex}
                            className={css.children}
                            checked={check.includes(child.key)}
                            onChange={(value, e) => handleChange(e)}
                            value={child.key}>
                            {child.name}
                          </Checkbox>
                        ))}
                      </div>
                    ) : null}
                  </div>
                ))}
              </ItemWrapper>
            </TopContainer>
          ),
        },
      ]}
    />
  );
};
export default memo(CheckItem);
